jQuery(document).ready(function ($) {

    /**
    * Follow link in case option has a link
    */
    $('select.wp-block-custom-blocks-dropdown').on('click change', function () {

        if (!$(this).find(':selected').hasClass('has-link') || !$(this).val() || !$(this).val().indexOf('http')) return;

        window.open($(this).val(), $(this).find(':selected').attr('target'));

    });


});


// WEBPACK FOOTER //
// ./src/blocks/dropdown/js/script.js